"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _MarginOverviewComponent = _interopRequireDefault(require("./MarginOverviewComponent"));
var _selectors = require("../../../redux/margin/selectors");
var _marginHelper = require("../../../helpers/marginHelper");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _state$product$produc;
  var summary = state.margin.accountInfo;
  var riskLevel = (0, _marginHelper.getRiskLevel)(summary.RiskLevel, summary.InMarginCall, summary.InLiquidation);
  var baseCurrency = (0, _productsSelectors.baseNotionalProductSymbolSelector)(state);
  var baseCurrencyDecimalPlaces = (_state$product$produc = state.product.products.find(function (product) {
    return product.Product === baseCurrency;
  })) === null || _state$product$produc === void 0 ? void 0 : _state$product$produc.DecimalPlaces;
  return {
    fetching: (0, _selectors.selectMarginConfig)(state).fetching,
    baseCurrency: baseCurrency,
    summary: summary,
    riskLevelNumber: summary.RiskLevel,
    riskLevel: riskLevel === null || riskLevel === void 0 ? void 0 : riskLevel.level,
    riskLabel: riskLevel === null || riskLevel === void 0 ? void 0 : riskLevel.label,
    baseCurrencyDecimalPlaces: baseCurrencyDecimalPlaces
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_MarginOverviewComponent["default"]);